export function onTop (beh) {
    window.scrollTo({
        top: 0,
        behavior: beh
    })
}
